import auth from "./auth";
import api from "./api";

const BASE_SERVICE_URL = "audit-trail-service";

export default {
    getActivityLogs(page, payload) {
        return new Promise((resolve, reject) => {
            api.post(
                `${BASE_SERVICE_URL}/get-merchant-cms-logs/${page}`,
                payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    return reject(status, error);
                });
        });
    }
};
